// extracted by mini-css-extract-plugin
module.exports = {"container":"Configurator__container","app":"Configurator__app","hint":"Configurator__hint","radio":"Configurator__radio"};